import { RefObject } from 'react';

import type { TransitionProps } from '@mantine/core';
import { Box, Transition as MantineTransition } from '@mantine/core';

const Transition = (props: TransitionProps) => <MantineTransition {...props} />;
interface TransitionElementProps extends Partial<TransitionProps> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  mounted: boolean;
  targetRef?: RefObject<HTMLDivElement>;
}

const TransitionElement = ({ children, targetRef, ...props }: TransitionElementProps) => {
  return (
    <Box ref={targetRef}>
      <Transition transition="fade" duration={150} timingFunction="ease" {...props}>
        {(styles) => <Box style={styles}>{children}</Box>}
      </Transition>
    </Box>
  );
};

Transition.Element = TransitionElement;

export { Transition, TransitionElement };
export type { TransitionElementProps };
